import ensureAffirmModalReady from 'commons/ensureAffirmModalReady';
import { logError } from './logger';

const learnMoreClick = async affirmButtonRef => {
  try {
    const affirmLinkOrButton = await ensureAffirmModalReady(affirmButtonRef);
    affirmLinkOrButton.click?.();
  } catch (err) {
    logError(
      err,
      {
        type: 'affirm',
      },
      {
        affirm: !!window.affirm,
        firstChild: !!affirmButtonRef?.current?.firstChild,
      }
    );
  }
};

export default learnMoreClick;
